import Reveal from "@/components/Reveal";
import { Globe2, BadgeCheck } from "lucide-react";

const Facilitator = () => (
  <section id="facilitadora" className="relative border-t border-white/10 bg-wine/30 py-28 md:py-40" data-testid="facilitator-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-center gap-16 md:grid-cols-12">
        <div className="relative md:col-span-5">
          <Reveal>
            <div className="relative overflow-hidden border border-white/10" data-testid="facilitator-portrait">
              <img
                src="/assets/maria-cerebro.webp"
                alt="María Elizabeth Samaniego Huber sosteniendo un modelo de cerebro"
                className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-plum/80 via-transparent to-transparent" />
            </div>
          </Reveal>
          <span
            aria-hidden
            className="pointer-events-none absolute -left-6 top-1/2 hidden -translate-y-1/2 -rotate-90 font-display text-xs font-bold uppercase tracking-[0.5em] text-lilac/40 lg:block"
          >
            Facilitadora
          </span>
        </div>

        <div className="md:col-span-7">
          <Reveal>
            <p className="mb-6 text-xs font-medium uppercase tracking-[0.35em] text-magenta">
              Quién guía el recorrido
            </p>
            <h2 className="font-display text-4xl font-black uppercase leading-[0.95] tracking-tighter md:text-6xl">
              María Elizabeth <span className="text-stroke-magenta">Samaniego Huber</span>
            </h2>
          </Reveal>
          <Reveal delay={0.12}>
            <ul className="mt-10 flex flex-col gap-3">
              {[
                "Directora de eye square para Latinoamérica",
                "Máster en Neuromarketing",
                "Fundadora de Meli Market Minds",
              ].map((cred) => (
                <li key={cred} className="flex items-center gap-3 text-sm uppercase tracking-[0.15em] text-rosewhite/90 md:text-base">
                  <BadgeCheck className="h-4 w-4 shrink-0 text-neoncyan" />
                  {cred}
                </li>
              ))}
            </ul>
            <p className="mt-8 max-w-xl text-sm leading-relaxed text-lilac/90 md:text-base">
              María trabaja en investigación y comportamiento del consumidor, aplicando
              neuromarketing, psicología del consumidor y tecnologías de investigación para
              ayudar a las marcas a comprender mejor cómo piensan y deciden sus clientes.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <div
              className="mt-12 border border-dashed border-violet/50 bg-violet/5 p-8"
              data-testid="guest-card"
            >
              <div className="flex items-center gap-3">
                <Globe2 className="h-5 w-5 text-violet" />
                <p className="font-display text-sm font-extrabold uppercase tracking-[0.25em] text-violet">
                  Invitado internacional
                </p>
              </div>
              <p className="mt-4 font-editorial text-2xl italic text-rosewhite/90 md:text-3xl">
                Por confirmar
              </p>
              <p className="mt-3 max-w-md text-xs leading-relaxed text-lilac/80 md:text-sm">
                El curso contará con la participación especial de un invitado internacional que
                compartirá conocimientos, experiencias y casos de comportamiento del consumidor,
                neuromarketing e investigación aplicada a marcas.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default Facilitator;
